module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/instagram.5572f9e0.svg";